import type {ReactElement, ReactNode} from 'react';
import Logo from '@components/Logo/Logo';
import {clsx} from 'clsx';
import styles from './index.module.scss';

interface Props {
    className?: string;
    children: ReactNode;
}

export default function ContentBlock(props: Props): ReactElement<Props> {
    const classNames = clsx({
        [styles.root]: true,
        [props.className as string]: props.className,
    });

    return (
        <div className={classNames}>
            <Logo className={styles.logo} />
            {props.children}
        </div>
    );
}
